<template>
    <div class="auth-wrapper middle-aligner">
        <div class="inner">
            <div class="card card-auth  with-shadow">
                <h2 class="auth-heading">
                    Create password
                    <span>
                        Please create your new account password.
                    </span>
                </h2>
                <div class="auth-body has-icon">
                    <b-form @submit.stop.prevent="onSubmit()">
                        <b-form-group
                            id="new-set-password-input"
                            label="NEW PASSWORD"
                            label-for="new-password"
                        >
                            <b-form-input
                                id="new-set-password-field"
                                ref="password"
                                v-model="formData.password"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                type="password"
                                placeholder="Enter your account password"
                                data-vv-name="new password"
                                :class="{
                                    'is-invalid': errors.has('new password'),
                                }"
                            ></b-form-input>

                            <div class="password-validation">
                                <i
                                    v-b-tooltip.hover
                                    class="icon-error_outline"
                                    placement="lefttop"
                                    title=" 
                                    - Password must be between 6-20 characters.
                                    - Password must contain at least 1 uppercase letter, 1 lowercase. letter, 1 numeric character and at least 1 symbol.
                                    - The symbols allowed are !@#$%^&amp;*_=+"
                                ></i>
                            </div>
                        </b-form-group>
                        <b-form-group
                            id="confirm-password-input"
                            label="CONFIRM PASSWORD"
                            label-for="confirm-password"
                        >
                            <b-form-input
                                id="confirm-password-field"
                                v-model="formData.passwordConfirmation"
                                v-validate="{
                                    required: true,
                                    confirmed: 'password',
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                type="password"
                                placeholder="Re-enter your account password"
                                data-vv-name="confirmation password"
                                :class="{
                                    'is-invalid': errors.has(
                                        'confirmation password'
                                    ),
                                }"
                            ></b-form-input>
                        </b-form-group>
                        <base-button
                            btn-label="CREATE"
                            btn-type="submit"
                            btn-variant="primary"
                            :disabled="loading"
                            :class="loading ? 'disabled' : ''"
                        ></base-button>
                        <base-toast></base-toast>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
const viewBrandingApi = new resource('configurations/branding')

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading']),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > created
    |--------------------------------------------------------------------------
    */
    async created() {
        // Change theme color
        await this.getBrandingData()
    }, // End of Component > created

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        if (this.$route.params && this.$route.params.token) {
            this.formData.token = this.$route.params.token
        }
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                password: '',
                passwordConfirmation: '',
                token: null,
            }
        }, // End of initializeFormData() methods

        async onSubmit() {
            const result = await this.$validator.validateAll()

            if (result) {
                try {
                    // auth SetPassword action in auth store
                    let response = await this.$store.dispatch(
                        'authCreatePassword',
                        this.formData
                    )
                    if (response) {
                        this.$router.push({ name: 'view-alerts' })
                        this.clearFormData()
                    }

                    // Clearing formData fields on submit
                } catch (error) {
                    console.log(error, 'There is an error on create password')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method

        clearFormData() {
            this.$validator.reset()
            Object.assign(this.formData, this.initializeFormData())
        }, // End of clearFormData() method
        async getBrandingData() {
            let { data } = await viewBrandingApi.list()
            this.$store.commit('setDisplaySetting', data.data)
        }, // End of getBrandingData() method
    }, // End of Component > methods
} // End of export default
</script>
